import React from 'react';
import { cn } from '@/lib/utils';

interface AllowanceColumnHeaderProps {
    headerName: string;
    className?: string;
}

function AllowanceColumnHeader({ headerName, className }: AllowanceColumnHeaderProps): React.JSX.Element {
    return (
        <span
            className={cn(
                'mx-auto block w-full max-w-full min-w-0 text-center text-xs leading-snug font-medium break-words whitespace-normal',
                className,
            )}
        >
            {headerName}
        </span>
    );
}

export default AllowanceColumnHeader;
